export const ON_CLICK_DEBOUNCE_WAIT = 500;
